


















































import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChatbotMessageFeedback, ChatbotMessageFeedbackResponse, ChatbotMsg } from '../../models/ChatbotMsg';
import { ColorsList, ID } from '../../../core/utils';
import { botMsgColor } from '../../utils'
import { MessageType } from '../../models/ChatConstants';
import LoadingIndicator from '../../../core/components/LoadingIndicator.vue';
import { RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper, CompanyStoreHelper, AuthStoreHelper, StoreHelper } from '../../../core/mixins';
import ChatbotMsgFeedbackText from './ChatbotMsgFeedbackText.vue';
@Component({
    components: {
      ChatbotMsgFeedbackText,
      LoadingIndicator
    }
})
export default class ChatbotMessageFeedbackEl extends Mixins(AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper) {
  @Prop({default: -1}) message_id: ID
  pendingFeedback: boolean = false;
  showFeedbackModal: boolean = false;

  onSentAditionalComments(comment: string) {
    this.showFeedbackModal = false
    this.callFeedbackAction(false, comment);
  }

  onThumbClick(isPositive: boolean) {
    if(isPositive){
      this.callFeedbackAction(true, '');
    }else{
      this.showFeedbackModal = true
    }
  }

  callFeedbackAction(isPositive: boolean, feedbackMsg: string) {
    this.pendingFeedback = true;
    let config:ChatbotMessageFeedback = {
      message_id: this.message_id,
      feedback: feedbackMsg,
      is_ok: isPositive
    }

    this.$_chatbotSendMessageFeedback(
      config
    ).then((res: ChatbotMessageFeedbackResponse) => {
     this.$_showAddPointOfInterest('Gracias! Tu feedback es muy importante para nosotros 🙂')
    }).catch((err) => {
      this.$_catchLoadingDialog({
          response: err.response.data || {},
          alternative_msg: 'No se pudo enviar tu feedback'
      })
    }).finally(() => {
      this.pendingFeedback = false;
    })
  }

  
   
}
